import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBarsStacked100 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={28}
    fill="none"
    {...props}
  >
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M10.419 4v4.74h7V4z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M5 4v4.741h5.419V4z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M16.809 4v4.74h9.645c.748 0 1.355-.606 1.355-1.355v-2.03c0-.749-.607-1.355-1.355-1.355zm3 7.451v4.74h6.645c.748 0 1.355-.606 1.355-1.354v-2.031c0-.748-.607-1.355-1.355-1.355z"
      clipRule="evenodd"
    />
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M13.809 11.451v4.74h6v-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M5 11.451v4.741h9.482v-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#98B9FA"
      fillRule="evenodd"
      d="M12.809 18.902v4.74h8v-4.74z"
      clipRule="evenodd"
    />
    <path
      fill="#427FF8"
      fillRule="evenodd"
      d="M5 18.902v4.742h8.128v-4.742z"
      clipRule="evenodd"
    />
    <path
      fill="#C8D9FC"
      fillRule="evenodd"
      d="M20.809 18.902v4.74h5.645c.748 0 1.355-.606 1.355-1.354v-2.031c0-.748-.607-1.355-1.355-1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBarsStacked100;
